import { put, fork, call, takeEvery, all, select } from 'redux-saga/effects';
import app from '../../app';
import {
  loadGroupListCompletion,
  loadGroupCompletion,
  loadGroupWaitListCompletion,
  overGroupCompletion,
  loadGroupThemeBannerListCompletion,
  loadGroupThemeListCompletion,
  loadGroupThemeTipShowCompletion,
  catchError,
} from '../../actions';

export function* watchLoadGroupList() {
  yield takeEvery('LOAD_GROUP_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.group.master);
    const tabDict = { all: '', wait: 1, success: 2, fail: 3 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const options = {
      url: `/api/pt/group/list?start=${start}&size=${query.size}&status=${tab}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadGroupListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadGroup() {
  yield takeEvery('LOAD_GROUP', function*({ id, isOrder }) {
    const options = {
      url: !isOrder ? `/api/pt/group/${id}` : `/api/pt/order/${id}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadGroupCompletion(result.error, result.data));
  });
}

export function* watchLoadGroupWaitList() {
  yield takeEvery('LOAD_GROUP_WAIT_LIST', function*({ productId }) {
    const options = {
      url: `/api/pt/group/crowd/${productId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadGroupWaitListCompletion(
        result.error,
        (result.data && result.data.listData) || [],
        (result.data && result.data.count) || 0
      )
    );
  });
}

export function* watchOverGroup() {
  yield takeEvery('OVER_GROUP', function*({ groupId }) {
    const options = {
      url: `/api/pt/overPt/${groupId}`,
      method: 'POST'
    };
    const result = yield call(app.httpFetch, options);
    yield put(overGroupCompletion(result.error, result.data));
    if (result.error) {
      yield put(catchError(result.error));
    }
  })
}

export function* watchLoadGroupThemeBannerList() {
  yield takeEvery('LOAD_GROUP_THEME_BANNER_LIST', function* ({ client }) {
    const result = yield call(app.httpFetch, { url: '/api/pt/theme/banner/list', data: { client } });
    yield put(loadGroupThemeBannerListCompletion(result.error, result.data));
  })
}

export function* watchLoadGroupThemeList() {
  yield takeEvery('LOAD_GROUP_THEME_LIST', function* () {
    const result = yield call(app.httpFetch, { url: '/api/pt/theme/list' });
    yield put(loadGroupThemeListCompletion(result.error, result.data));
  })
}

export function* watchLoadGroupThemeTipShow() {
  yield takeEvery('LOAD_GROUP_THEME_TIP_SHOW', function* () {
    const result = yield call(app.httpFetch, { url: '/api/pt/theme/tips' });
    yield put(loadGroupThemeTipShowCompletion(result.error, result.data));
  })
}

export default function* groupSaga() {
  yield all([
    fork(watchLoadGroupList),
    fork(watchLoadGroup),
    fork(watchLoadGroupWaitList),
    fork(watchOverGroup),
    fork(watchLoadGroupThemeBannerList),
    fork(watchLoadGroupThemeList),
    fork(watchLoadGroupThemeTipShow)
  ]);
}
